import { Model } from "@lumora/core";

export interface LegalSection {
  heading: string;
  paragraphs: string[];
}

export const DRAFT_BANNER = "DRAFT - have a lawyer review before relying on this";

/** A legal page as data: title, last-updated date, always-on draft banner, sections. */
export class LegalDocument extends Model {
  readonly banner = DRAFT_BANNER;

  constructor(
    readonly title: string,
    readonly updated: string,
    readonly sections: readonly LegalSection[],
  ) {
    super();
  }

  validate(): string[] {
    return this.sections.length === 0 ? ["A legal document needs at least one section."] : [];
  }

  /** All text, flattened. Used by tests. */
  plainText(): string {
    return [this.title, ...this.sections.flatMap((s) => [s.heading, ...s.paragraphs])].join("\n");
  }
}
